import React, { useState } from 'react';
import Type from 'prop-types';
import { noop } from 'lodash';
import { useQuery } from 'react-query';
import { getIn } from 'formik';
import { ListPickerButton } from 'components/Pickers/NewListPicker/components';
import NewListPicker from '../../Pickers/NewListPicker';

const ListPickerField = (props) => {
  const {
    field,
    form: { errors, setFieldValue },
    onSearch,
    onChange,
    queryConfig,
    SearchViewProps,
    options,
    disabled = false,
    emptyText = undefined,
    ListPickerButtonProps,
    ...other
  } = props;
  const values = [].concat(field.value ?? []).filter((value) => value !== '');
  const [inputValue, setInputValue] = useState('');
  const fieldError = getIn(errors, field.name);
  const showError = !!fieldError;
  const { queryFn, ...restQueryConfig } = queryConfig;

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
  };

  const handleChange = (event, newValue) => {
    setFieldValue(field.name, newValue);
    onChange(event, newValue);
  };

  const searchValue = inputValue.trim();

  const searchQuery = useQuery({
    queryFn: () => queryFn({ query: searchValue }),
    enabled: false,
    initialData: [],
    ...restQueryConfig,
  });

  const { refetch, data, isFetching } = searchQuery;

  const handleSearch = () => {
    if (SearchViewProps.freeSolo && searchValue) {
      refetch();
    }
  };

  return (
    <NewListPicker
      value={values}
      inputValue={inputValue}
      onChange={handleChange}
      onInputChange={handleInputChange}
      onSearch={handleSearch}
      helperText={fieldError}
      options={SearchViewProps.freeSolo ? data : options}
      SearchViewProps={{
        ...SearchViewProps,
        loading: isFetching,
      }}
      ListPickerButtonProps={{
        InputLabelProps: {
          error: showError,
        },
        FormHelperTextProps: {
          error: showError,
        },
        disabled,
        emptyText,
        ...ListPickerButtonProps,
      }}
      {...other}
    />
  );
};

ListPickerField.propTypes = {
  label: Type.string.isRequired,
  field: Type.shape({
    name: Type.string.isRequired,
    value: Type.oneOfType([
      Type.arrayOf(Type.oneOfType([Type.object, Type.string])),
      Type.string,
    ]),
  }).isRequired,
  form: Type.shape({
    setFieldValue: Type.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    errors: Type.object,
  }).isRequired,
  queryConfig: Type.shape({
    queryKey: Type.arrayOf(Type.string),
    queryFn: Type.func,
  }),
  options: Type.arrayOf(Type.oneOfType([Type.string, Type.object])),
  SearchViewProps: Type.shape({
    freeSolo: Type.bool,
  }),
  onSearch: Type.func,
  onChange: Type.func,
  firstLoad: Type.bool,
  disabled: Type.bool,
  emptyText: Type.string,
  ListPickerButtonProps: Type.shape(ListPickerButton.propTypes),
};

ListPickerField.defaultProps = {
  onSearch: noop,
  onChange: noop,
  options: [],
  queryConfig: {},
  SearchViewProps: {},
  disabled: false,
  emptyText: undefined,
  ListPickerButtonProps: undefined,
  firstLoad: false,
};

export default ListPickerField;
